import { StandardStrapiFields } from '../../types/strapi/strapi'
import { mergeRefreshedValue } from './merge-refreshed-value'

type RowWithDocumentId = Pick<StandardStrapiFields, 'documentId'>

/** Накладывает свежие поля на строки таблицы, не меняя их состав и порядок */
export function mergeRefreshedRows<T extends RowWithDocumentId>(
    rows: T[],
    refreshedRows: Partial<T>[]
): T[] {
    if (!refreshedRows.length) {
        return rows
    }

    const refreshedById = new Map(refreshedRows.map(row => [row.documentId, row]))

    return rows.map(row => {
        const refreshed = refreshedById.get(row.documentId)
        return refreshed ? (mergeRefreshedValue(row, refreshed) as T) : row
    })
}
